<template>
  <div class="login">
    <div class="login-box">
      <div class="login-title">TATA物流平台</div>
      <div class="login-aiwrap"></div>
      <div class="login-from">
        <input class="userName" type="text" placeholder="请输入用户名" v-model="username" />
        <input class="passwrrd" type="password" placeholder="请输入密码" v-model="password" />
        <div class="tip" v-if="!isValidPassword">密码长度不能小于8位且不能大于20位字符,必须包含字母、数字和特殊符号。</div>
        <div class="deng" @click="getLogin()">登录</div>
      </div>
    </div>
    <div v-if="this.succeed" class="succeed">
      <span class="iconfont icon-xiaolian"></span>
      正在登录中...
    </div>
    <div v-if="this.defeated" class="defeated">
      <span class="iconfont icon-kulian"></span>
      用户名或密码错误...
    </div>
  </div>
</template>

<script>
export default {
   computed: {
    isValidPassword() {
      // const regex = /^(?=.*[a-z])(?=.*[A-Z]).{8,20}$/;
      // 密码校验 长度不能小于8位且不能大于20位字符,必须包含大写字母、小写字母、数字和特殊符号
	    var regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[\W_]).{8,20}$/;
      return regex.test(this.password);
    }
  },
  data() {
    return {
      username: "",
      password: "",
      timer: null,
      timers: null,
      succeed: false,
      defeated: false,
      //顶部铃铛权限
      orgType: "",
      organizationCode: "",
      carriersCode: "",
    };
  },
  created() {
    if (this.$router.path !== "/") {
      this.$router.replace("/");
    }
    let that = this;
    document.onkeydown = function (e) {
      e = window.event || e;
      if (
        that.$route.path === "/" &&
        (e.code === "Enter" || e.code === "enter")
      ) {
        //验证在登录界面和按得键是回车键enter
        that.getLogin();
      }
    };
  },
  methods: {
    getLogin() {
      if(!this.isValidPassword) {
        return
      }
      this.axios({
        method: "post",
        url: "/les/basics/city/queryCityList",
      }).then((res) => {
        sessionStorage.setItem("cityList1",JSON.stringify(res.data));
      });
      this.axios({
        method: "post",
        url: "/les/system/user/login",
        params: {
          username: this.username,
          password: this.password,
        },
      }).then((res) => {
        console.log(res);
        if (res.data.success === true) {
          this.orgType = res.data.result.orgType;
          this.organizationCode = res.data.result.organizationCode;
          this.carriersCode = res.data.result.carriersCode;
          sessionStorage.setItem("orgType", this.orgType);
          sessionStorage.setItem("organizationCode", this.organizationCode);
          sessionStorage.setItem("carriersCode", this.carriersCode);
          sessionStorage.setItem("userName", this.username);
          sessionStorage.setItem("password", this.password);
          sessionStorage.setItem("lastClickTime", new Date().getTime());
          sessionStorage.setItem("token", "token");
          this.succeed = true;
          this.timer = setInterval(() => {
            this.$router.replace("/Home");
          }, 3000);
          this.$store.state.userName = sessionStorage.getItem("userName");
        } else {
          this.defeated = true;
          this.timers = setTimeout(() => {
            this.defeated = false;
          }, 2000);
        }
      });
    },
  },
  components: {},
  beforeDestroy() {
    clearInterval(this.timer);
    clearTimeout(this.timers);
    this.timer = null;
    this.timers = null;
  },
};
</script>

<style scoped>
.login {
  width: 100%;
  height: 100%;
  background: url("../assets/images/bg.png") center center no-repeat;
  background-size: 100% 100%;
  display: flex;
  position: relative;
}
.login-box {
  position: relative;
  width: 420px;
  height: 420px;
  border-radius: 4px;
  margin: auto;
  background: #ffffff;
}
.login-title {
  position: absolute;
  left: -18px;
  top: 60px;
  width: 338px;
  height: 55.2px;
  line-height: 55.2px;
  font-size: 14px;
  color: #ffffff;
  padding: 0 0 0 60px;
  background: #29406c;
}
.login-aiwrap {
  width: 18px;
  height: 10px;
  position: absolute;
  left: -18px;
  top: 115.2px;
  background: url("../assets/images/aiwrap.png");
}
.login-from {
  width: 340px;
  height: 188px;
  margin: 145px auto;
}
.userName {
  width: 308px;
  height: 50px;
  font-size: 13px;
  padding: 0 16px;
  border: 1px solid #dcdee0;
  vertical-align: middle;
  border-radius: 3px;
  margin-bottom: 24px;
}
.passwrrd {
  width: 308px;
  height: 50px;
  font-size: 13px;
  padding: 0 16px;
  border: 1px solid #dcdee0;
  vertical-align: middle;
  border-radius: 3px;
  margin-bottom: 10px;
}
.deng {
  width: 340px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  vertical-align: middle;
  cursor: pointer;
  font-size: 18px;
  color: #ffffff;
  background: #29406c;
}
.defeated,
.succeed {
  width: 229px;
  height: 82px;
  line-height: 80px;
  text-align: center;
  position: absolute;
  font-size: 18px;
  left: 50%;
  top: 50%;
  transform: translateX(-50%);
  background: #ffffff;
  border: 1px solid #d3d4d3;
}
.icon-xiaolian {
  color: green !important;
  font-size: 35px !important;
  vertical-align: middle;
}
.icon-kulian {
  color: red !important;
  font-size: 35px !important;
  vertical-align: middle;
}
.tip{
  color: red;
  margin-bottom: 10px;
}
</style>
